import { render } from "./CustomNodeEditPage.vue?vue&type=template&id=484fdce2&scoped=true"
import script from "./CustomNodeEditPage.vue?vue&type=script&lang=js"
export * from "./CustomNodeEditPage.vue?vue&type=script&lang=js"

import "./CustomNodeEditPage.vue?vue&type=style&index=0&id=484fdce2&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484fdce2"]])

export default __exports__